// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"641839fc","369":"dc607e51","422":"81b3f72a","787":"89bf4bed","820":"bcfa9378","874":"6cf3f2ea","875":"8ba08136"}[chunkId] + ".chunk.js";
};